import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export default function WhatsAppFloat() {
  const number = COMPANY.whatsapp.replace(/\D/g, "");
  const msg = encodeURIComponent(
    "Hi ISGS — I'd like to enquire about your asbestos consulting services."
  );
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <div className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] group-hover:scale-110 transition-transform">
          <MessageCircle size={26} fill="currentColor" />
        </div>
      </div>
      <div className="absolute right-16 bottom-1/2 translate-y-1/2 hidden group-hover:flex items-center bg-[#0E2A5C] text-white text-[13px] font-medium px-4 py-2 rounded-full whitespace-nowrap shadow-lg">
        Chat with us on WhatsApp
      </div>
    </a>
  );
}
